import { EnergyOrderOverviewPermissions } from '@backoffice/shared/bo/util-permissions';
import { faPlug } from '@fortawesome/pro-solid-svg-icons';
import { ngxPermissionsGuard } from 'ngx-permissions';

export const contractOverviewRoute = {
  path: 'overview',
  canActivate: [ngxPermissionsGuard],
  loadComponent: () =>
    import('./feature-overview.component').then(
      (mod) => mod.FeatureOverviewComponent,
    ),
  data: {
    translate: 'contracts.overview',
    titleIcon: {
      icon: faPlug,
      class: 'power-icon',
    },
    permissions: {
      only: [
        EnergyOrderOverviewPermissions.contractOverviewPower,
        EnergyOrderOverviewPermissions.contractOverviewGas,
      ],
    },
  },
};

export const contractOverviewDetailPowerRoute = {
  path: 'overview/power/details/:id',
  canActivate: [ngxPermissionsGuard],
  loadComponent: () =>
    import(
      './components/cc-contract-overview-details/cc-contract-overview-details-power/cc-contract-overview-details.component'
    ).then((mod) => mod.CcContractOverviewDetailsComponent),
  data: {
    permissions: {
      only: [EnergyOrderOverviewPermissions.contractOverviewPower],
    },
  },
};

export const contractOverviewDetailGasRoute = {
  path: 'overview/gas/details/:id',
  canActivate: [ngxPermissionsGuard],
  loadComponent: () =>
    import(
      './components/cc-contract-overview-details/cc-contract-overview-details-gas/cc-contract-overview-details-gas.component'
    ).then((mod) => mod.CcContractOverviewDetailsGasComponent),
  data: {
    permissions: {
      only: [EnergyOrderOverviewPermissions.contractOverviewGas],
    },
  },
};
